module.exports = __webpack_public_path__ + "img/video-loding.00e23fa9.gif";